import React from 'react'
import { Card } from 'antd'
import RegisterForm from './RegisterForm/RegisterForm'
import ExpertRegisterPromo from './ExpertRegisterPromo/ExpertRegisterPromo'

import './register.less'
import MemberRegisterPromo from './MemberRegisterPromo/MemberRegisterPromo'
import { useIntegrationContext } from '../../../context/integration'

const RegisterPage = () => {
	const {
		integration: { isInviteExpert, loading, onboarding },
	} = useIntegrationContext()
	return (
		<div className="register-container">
			<div className="mobile">
				{!loading && isInviteExpert && <ExpertRegisterPromo />}
				{!loading && !isInviteExpert && <MemberRegisterPromo />}
			</div>
			<Card bordered={false} className="register-card">
				<RegisterForm isPromo allowedIDPs={onboarding?.IDPs} allowedDomains={onboarding?.domains} />
			</Card>
			<div className="desktop">
				{!loading && isInviteExpert && <ExpertRegisterPromo />}
				{!loading && !isInviteExpert && <MemberRegisterPromo />}
			</div>
		</div>
	)
}

export default RegisterPage
